import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { NotificationsService } from "angular2-notifications";
import { of } from "rxjs";
import { catchError, map, switchMap, mergeMap } from "rxjs/operators";
import { AppState } from "src/app/app.reducer";
import { ErrorAction } from "src/app/login/store/auth.actions";
import { API } from "src/app/services/Api.service";
import { GetProjects, GetProjectsSucess, MonitoringEvaluationActionTypes, GetIndicatorDetails, GetIndicatorDetailsSuccess, GetListDetails, GetListDetailsSuccess, AddNewValue, AddNewValueSucess, GetIndicatorActivityLog, GetIndicatorActivityLogSuccess, RemoveIndicator, RemoveIndicatorSuccess, GetIndicatorValuesActivityLog, GetInnovationDetails, GetInnovationDetailsSuccess, UpdateInnovationMatrix, UpdateInnovationMatrixSuccess, IndicatorOperations, IndicatorOperationsSuccess, RolesAndResponsibilites, RolesAndResponsibilitesSuccess, CreateRolesAndResponsibilites, CreateRolesAndResponsibilitesSucess, GetInstitutionalCoordination, GetInstitutionalCoordinationSuccess, CreateInstitutionalCoordination, CreateInstitutionalCoordinationSucess, GetProjectDataManagement, GetProjectDataManagementSuccess, CreateProjectDataManagement, CreateProjectDataManagementSucess, GetSingleInstitutionalCoordination, GetSingleInstitutionalCoordinationSuccess, GetPhysicalProgressSuccess, GetPhysicalProgress, CreatePhysicalProgress, CreatePhysicalProgressSucess, GetFinancialProgress, GetFinancialProgressSuccess, CreateFinancialProgress, CreateFinancialProgressSucess, GetSinglePhysicalProgress, GetSinglePhysicalProgressSuccess, GetSingleFinancialProgress, GetSingleFinancialProgressSuccess, GetMajorEventsIndicators, GetMajorEventsIndicatorsSuccess, GetQuarters, GetQuartersSuccess, GetMonitoringTypes, GetMonitoringTypesSuccess, GetCircumstancesActions, GetCircumstancesActionsSuccess, CreateCircumstances, CreateCircumstancesSucess, GetSingleCircumstances, GetSingleCircumstancesSucess, GetCapacityBuilding, GetCapacityBuildingSuccess, GetCapacityBuildingDetail, GetCapacityBuildingDetailSuccess, CreateCapacityBuilding, CreateCapacityBuildingSuccess, EditCapacityBuilding, EditCapacityBuildingSuccess, GetPeerExchange, GetPeerExchangeSuccess, GetPeerExchangeDetail, GetPeerExchangeDetailSuccess, CreatePeerExchange, CreatePeerExchangeSuccess, EditPeerExchange, EditPeerExchangeSuccess, GetCommunicationOutreach, GetCommunicationOutreachSuccess, GetCommunicationOutreachDetailSuccess, GetCommunicationOutreachDetail, CreateCommunicationOutreachSuccess, CreateCommunicationOutreach, EditCommunicationOutreach, GetQuestionsJson, GetQuestionsJsonSuccess, GetSingleProjectDataManagement, GetSingleProjectDataManagementSuccess, SendApproval, SendApprovalSuccess, GetSingleRoleandResp, GetSingleRoleandRespSuccess, UpdateOtherObservationsSuccess, UpdateOtherObservations, GetOtherObservations, GetOtherObservationsSuccess, UpdateMajorEvents, UpdateMajorEventsSuccess, Approve, ApproveSuccess, ReopenTable, ReopenTableSuccess, GetOverViewPLFOne, GetOverViewPLFOneSuccess, GetOverViewPLFTwo, GetOverViewPLFTwoSuccess, GetOverViewDetails, GetOverViewDetailsSuccess, CreateIndicator, CreateIndicatorSuccess, EditIndicator, EditIndicatorSuccess, SuggestIndicator, SuggestIndicatorSuccess, BlukIndicator, BlukIndicatorSuccess ,GetInnovationActivityLogSuccess, GetInnovationActivityLog, GetBiAnnualOverViewDetails, GetBiAnnualOverViewDetailsSuccess } from "./monitoring-evaluation.actions";
import { MonitoringEvaluationService } from "../monitoring-evaluation.service";
import { Location } from '@angular/common';
import { Router } from "@angular/router";
import { LoaderHide } from "src/app/features/loader/store/loader.actions";

@Injectable()
export class MonitoringEvaluationEffects {
    constructor(private api: API,
        private monitoring_service: MonitoringEvaluationService,
        private action$: Actions,
        private location: Location,
        private store: Store<AppState>,
        private notificationService: NotificationsService,
        private router: Router,
    ) { }

    @Effect()
    getProjects$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_PROJECTS),
        switchMap((action: GetProjects) => {
            console.log("asda ")
            return this.api.getProjects(action.params).pipe(
                map((response: any) => {
                    return new GetProjectsSucess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getMasterList$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_LIST_DETAILS),
        switchMap((action: GetListDetails) => {
            if (action.list_type == 'master_list') {
                return this.monitoring_service.getMasterList(action.payload).pipe(
                    map((response: any) => {
                        return new GetListDetailsSuccess(response);
                    }),
                    catchError(err => of(new ErrorAction(err)))
                );
            }

            if (action.list_type == 'spv') {
                return this.monitoring_service.getSpvList(action.payload).pipe(
                    map((response: any) => {
                        return new GetListDetailsSuccess(response);
                    }),
                    catchError(err => of(new ErrorAction(err)))
                );
            }
            if (action.list_type == 'suggested_list') {
                return this.monitoring_service.getSuggestedList(action.payload).pipe(
                    map((response: any) => {
                        this.store.dispatch(new LoaderHide());
                        return new GetListDetailsSuccess(response);
                    }),
                    catchError(err => of(new ErrorAction(err)))
                );
            }
            if (action.list_type == 'rejected_list') {
                return this.monitoring_service.getRejectedList(action.payload).pipe(
                    map((response: any) => {
                        return new GetListDetailsSuccess(response);
                    }),
                    catchError(err => of(new ErrorAction(err)))
                );
            }
            // if(action.type == 'master_list')
            // {
            //     return this.monitoring_service.getMasterList(action.id).pipe(
            //         map((response: any) => {
            //             return new GetMasterListSuccess(response);
            //         }),
            //         catchError(err => of(new ErrorAction(err)))
            //     );
            // }
        })
    );

    @Effect()
    getIndicatorDetails$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_INDICATOR_DETAILS),
        switchMap((action: GetIndicatorDetails) => {
            if (action.indicator_type == 'spv') {
                return this.monitoring_service.getSPVIndicatorDetails(action.id).pipe(
                    map((response: any) => {
                        console.log(response)
                        return new GetIndicatorDetailsSuccess(response);
                    }),
                    catchError(err => of(new ErrorAction(err)))
                );
            }

            if (action.indicator_type == 'master') {
                return this.monitoring_service.getIndicatorDetails(action.id).pipe(
                    map((response: any) => {
                        console.log(response)
                        return new GetIndicatorDetailsSuccess(response);
                    }),
                    catchError(err => of(new ErrorAction(err)))
                );
            }
        })
    );

    @Effect()
    addNewValue$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.ADD_NEW_VALUE),
        switchMap((action: AddNewValue) => {
            console.log("asda ")
            return this.monitoring_service.addValues(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Value added successfully`);
                    return new AddNewValueSucess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getIndicatorActivity$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.INDICATOR_ACTIVITY),
        switchMap((action: GetIndicatorActivityLog) => {
            console.log("asda ")
            return this.monitoring_service.getIndicatorActivityLog(action.id).pipe(
                map((response: any) => {
                    return new GetIndicatorActivityLogSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getInnovationActivity$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.INNOVATION_ACTIVITY),
        switchMap((action: GetInnovationActivityLog) => {
            console.log("asda ")
            return this.monitoring_service.getInnovationActivityLog(action.projId).pipe(
                map((response: any) => {
                    return new GetInnovationActivityLogSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getIndicatorValuesActivity$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.INDICATOR_VALUES_ACTIVITY),
        switchMap((action: GetIndicatorValuesActivityLog) => {
            console.log("asda ")
            return this.monitoring_service.getIndicatorValuesActivityLog(action.projId, action.id).pipe(
                map((response: any) => {
                    return new GetIndicatorActivityLogSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    removeIndicator$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.REMOVE_INDICATOR),
        switchMap((action: RemoveIndicator) => {
            console.log("asda ")
            return this.monitoring_service.removeIndicator(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Removed successfully`);
                    return new RemoveIndicatorSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getInnovationDetails$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_INNOVATION_DETAILS),
        switchMap((action: GetInnovationDetails) => {
            console.log("asda ")
            return this.monitoring_service.getInnovationDetails(action.payload).pipe(
                map((response: any) => {
                    return new GetInnovationDetailsSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    updateInnovationMatrix$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.UPDATE_INNOVATION_MATRIX),
        switchMap((action: UpdateInnovationMatrix) => {
            console.log("asda ")
            return this.monitoring_service.updateInnovationMatrix(action.payload, action.id, action.quarter).pipe(
                map((response: any) => {
                    this.notificationService.success(`Updated successfully`);
                    this.router.navigate([`home/program-dashboard/project/${action.id}/m-e/project-monitoring`])
                    return new UpdateInnovationMatrixSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    indicatorOperations$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.INDICATOR_OPERATIONS),
        switchMap((action: IndicatorOperations) => {
            if (action.operation_type == 'accept') {
                return this.monitoring_service.acceptIndicator(action.id).pipe(
                    map((response: any) => {
                        this.notificationService.success(`Indicator accepted successfully`);
                        return new IndicatorOperationsSuccess(response, action.id);
                    }),
                    catchError(err => of(new ErrorAction(err)))
                );
            }
            if (action.operation_type == 'reject') {
                return this.monitoring_service.rejectIndicator(action.id).pipe(
                    map((response: any) => {
                        this.notificationService.success(`Indicator Rejected successfully`);
                        return new IndicatorOperationsSuccess(response, action.id);
                    }),
                    catchError(err => of(new ErrorAction(err)))
                );
            }
        })
    );

    @Effect()
    rolesAndResponsibilites$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.ROLES_AND_RESPONSIBILITES),
        switchMap((action: RolesAndResponsibilites) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.rolesandresponsibilites(action.payload).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new RolesAndResponsibilitesSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }

        })
    );

    @Effect()
    createRolesResp$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.CREATE_ROLES_RESPONSIBILITES),
        switchMap((action: CreateRolesAndResponsibilites) => {
            console.log("asda ")
            return this.monitoring_service.createRolesResp(action.payload, action.isEdit).pipe(
                map((response: any) => {
                    this.notificationService.success(`Value added successfully`);
                    this.router.navigate([`home/program-dashboard/project/${action.payload.projectId}/m-e/project-monitoring`])
                    return new CreateRolesAndResponsibilitesSucess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );


    @Effect()
    institutionalCoordination$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_INSTITUTIONAL_COORDINATION),
        switchMap((action: GetInstitutionalCoordination) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.institutionalCoordination(action.payload).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetInstitutionalCoordinationSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }

        })
    );

    @Effect()
    createInstitutationalCoord$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.CREATE_INSTITUTAINAL_COORDINATION),
        switchMap((action: CreateInstitutionalCoordination) => {
            console.log("asda ")
            return this.monitoring_service.createInstCoord(action.payload, action.isEdit).pipe(
                map((response: any) => {
                    this.notificationService.success(`Value added successfully`);
                    this.router.navigate([`home/program-dashboard/project/${action.payload.projectId}/m-e/project-monitoring`])
                    return new CreateInstitutionalCoordinationSucess(response);
                }),
                catchError(err => {
                    console.log(err, "err")

                    return of(new ErrorAction(err))
                })
            );
        })
    );

    @Effect()
    projDataManagement$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_PROJECT_DATA_MANAGEMENT),
        switchMap((action: GetProjectDataManagement) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.getProjdataManagement(action.payload).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetProjectDataManagementSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }

        })
    );

    @Effect()
    createprojDataManagement$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.CREATE_PROJECT_DATA_MANAGEMENTN),
        switchMap((action: CreateProjectDataManagement) => {
            if (action.payload.id) {
                return this.monitoring_service.editProjDataManagement(action.payload).pipe(
                    map((response: any) => {
                        this.notificationService.success(`Value Updated successfully`);
                        this.router.navigate([`home/program-dashboard/project/${action.payload.projectId}/m-e/project-monitoring`])
                        return new CreateProjectDataManagementSucess(response);
                    }),
                    catchError(err => {
                        console.log(err, "err")

                        return of(new ErrorAction(err))
                    })
                );
            } else {
                return this.monitoring_service.createProjDataManagement(action.payload).pipe(
                    map((response: any) => {
                        this.notificationService.success(`Value added successfully`);
                        this.router.navigate([`home/program-dashboard/project/${action.payload.projectId}/m-e/project-monitoring`])
                        return new CreateProjectDataManagementSucess(response);
                    }),
                    catchError(err => {
                        console.log(err, "err")

                        return of(new ErrorAction(err))
                    })
                );
            }

        })
    );

    @Effect()
    singleProjDataManagement$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_SINGLE_PROJECT_DATA_MANAGEMENT),
        switchMap((action: GetSingleProjectDataManagement) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.singleProjectDataManagement(action.id).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetSingleProjectDataManagementSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }

        })
    );

    @Effect()
    singlwInstitutionalCoordination$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_SINGLE_INSTITUTANAL_COORDINATION),
        switchMap((action: GetSingleInstitutionalCoordination) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.singleInstitutionalCoordination(action.id).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetSingleInstitutionalCoordinationSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }

        })
    );

    @Effect()
    getPhysicalProgress$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_PHYSICAL_PROGRESS),
        switchMap((action: GetPhysicalProgress) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.getPhysicalProgress(action.payload).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetPhysicalProgressSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }
        })
    );
    @Effect()
    getCapacityBuilding$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_CAPACITY_BUILDING),
        switchMap((action: GetCapacityBuilding) => {
            return this.monitoring_service.getCapacityBuilding(action.payload).pipe(
                map((response: any) => {
                    return new GetCapacityBuildingSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    createPhysicalProgress$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.CREATE_PHYSICAL_PROGRESS),
        switchMap((action: CreatePhysicalProgress) => {
            return this.monitoring_service.createPhysicalProgress(action.payload, action.isEdit).pipe(
                map((response: any) => {
                    this.notificationService.success(`Value added successfully`);
                    this.router.navigate([`home/program-dashboard/project/${action.payload.projectId}/m-e/physical-financial`])
                    return new CreatePhysicalProgressSucess(response);
                }),
                catchError(err => {
                    console.log(err, "err")

                    return of(new ErrorAction(err))
                })
            );
        })
    );

    @Effect()
    getCapacityBuildingDetail$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_CAPACITY_BUILDING_DETAIL),
        switchMap((action: GetCapacityBuildingDetail) => {
            return this.monitoring_service.getCapacityBuildingDetail(action.id).pipe(
                map((response: any) => {
                    return new GetCapacityBuildingDetailSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getFinancailProgress$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_FINANCIAL_PROGRESS),
        switchMap((action: GetFinancialProgress) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.getFinancailProgress(action.payload).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetFinancialProgressSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }
        })
    );

    @Effect()
    createCapacityBuilding$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.CREATE_CAPACITY_BUILDING),
        switchMap((action: CreateCapacityBuilding) => {
            return this.monitoring_service.createCapacityBuilding(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Created Successfully`);

                    return new CreateCapacityBuildingSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    createFinancailProgress$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.CREATE_FINANCAIL_PROGRESS),
        switchMap((action: CreateFinancialProgress) => {
            return this.monitoring_service.createFinancialProgress(action.payload, action.isEdit).pipe(
                map((response: any) => {
                    this.notificationService.success(`Value added successfully`);
                    this.router.navigate([`home/program-dashboard/project/${action.payload.projectId}/m-e/physical-financial`])
                    return new CreateFinancialProgressSucess(response);
                }),
                catchError(err => {
                    console.log(err, "err")

                    return of(new ErrorAction(err))
                })
            );
        })
    );

    @Effect()
    editCapacityBuilding$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.EDIT_CAPACITY_BUILDING),
        switchMap((action: EditCapacityBuilding) => {
            return this.monitoring_service.editCapacityBuilding(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Updated Successfully`);
                    return new EditCapacityBuildingSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    singleFinancialProgress$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_SINGLE_PHYSICAL_PROGRESS),
        switchMap((action: GetSinglePhysicalProgress) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.singlePhysicalProgress(action.id).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetSinglePhysicalProgressSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }
        })
    );

    @Effect()
    getPeerExchange$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_PEER_EXCHANGE),
        switchMap((action: GetPeerExchange) => {
            return this.monitoring_service.getPeerExchange(action.payload).pipe(
                map((response: any) => {
                    return new GetPeerExchangeSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    singlePhysicalProgress$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_SINGLE_FINANCIAL_PROGRESS),
        switchMap((action: GetSingleFinancialProgress) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.singleFinancialProgress(action.id).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetSingleFinancialProgressSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }
        })
    );

    @Effect()
    getPeerExchangeDetail$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_PEER_EXCHANGE_DETAIL),
        switchMap((action: GetPeerExchangeDetail) => {
            return this.monitoring_service.getPeerExchangeDetail(action.id).pipe(
                map((response: any) => {
                    return new GetPeerExchangeDetailSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getMajorEventsIndicators$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_MAJOR_EVENT_INDICATORS),
        switchMap((action: GetMajorEventsIndicators) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.getMajorEventIndicators(action.id).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetMajorEventsIndicatorsSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }
        })
    );

    @Effect()
    createPeerExchange$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.CREATE_PEER_EXCHANGE),
        switchMap((action: CreatePeerExchange) => {
            return this.monitoring_service.createPeerExchange(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Created Successfully`);
                    return new CreatePeerExchangeSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getQuarters$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_QUARTERS),
        switchMap((action: GetQuarters) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.getQuarters(action.payload).pipe(
                map((response: any) => {
                    // console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetQuartersSuccess(response, action.payload);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }
        })
    );

    @Effect()
    editPeerExchange$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.EDIT_PEER_EXCHANGE),
        switchMap((action: EditPeerExchange) => {
            return this.monitoring_service.editPeerExchange(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Updated Successfully`);
                    return new EditPeerExchangeSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getMonitoringTypes$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_MONITORING_TYPES),
        switchMap((action: GetMonitoringTypes) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.getMonitoringTypes(action.types).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetMonitoringTypesSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }
        })
    );

    @Effect()
    getCommunicationOutreach$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_COMMUNICATION_OUTREACH),
        switchMap((action: GetCommunicationOutreach) => {
            return this.monitoring_service.getCommunicationOutreach(action.payload).pipe(
                map((response: any) => {
                    return new GetCommunicationOutreachSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getCircumstances$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_CIRCUMSTANCES),
        switchMap((action: GetCircumstancesActions) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.getCircumstances(action.payload).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetCircumstancesActionsSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }
        })
    );

    @Effect()
    getCommunicationOutreachDetail$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_COMMUNICATION_OUTREACH_DETAIL),
        switchMap((action: GetCommunicationOutreachDetail) => {
            return this.monitoring_service.getCommunicationOutreachDetail(action.id).pipe(
                map((response: any) => {
                    return new GetCommunicationOutreachDetailSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    createCircumstances$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.CREATE_CIRCUMSTANCES),
        switchMap((action: CreateCircumstances) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.createCircumstances(action.payload).pipe(
                map((response: any) => {
                    console.log(response)
                    this.notificationService.success(`Updated Successfully`);
                    this.router.navigate([`home/program-dashboard/project/${action.payload.projectId}/m-e/E-S`])
                    return new CreateCircumstancesSucess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }

        })
    );
    @Effect()
    getsingleCircumstances$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_SINGLE_CIRCUMSTANCES),
        switchMap((action: GetSingleCircumstances) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.getSingleCircumstances(action.id).pipe(
                map((response: any) => {
                    console.log(response)
                    // this.notificationService.success(`Indicator accepted successfully`);
                    return new GetSingleCircumstancesSucess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }
        })
    );

    @Effect()
    createCommunicationOutreach$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.CREATE_COMMUNICATION_OUTREACH),
        switchMap((action: CreateCommunicationOutreach) => {
            return this.monitoring_service.createCommunicationOutreach(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Created Successfully`);
                    return new CreateCommunicationOutreachSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    editCommunicationOutreach$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.EDIT_COMMUNICATION_OUTREACH),
        switchMap((action: EditCommunicationOutreach) => {
            return this.monitoring_service.editCommunicationOutreach(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Updated Successfully`);
                    return new GetCommunicationOutreachSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getQuestionsJson$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_QUESTIONS_JSON),
        switchMap((action: GetQuestionsJson) => {
            return this.monitoring_service.getQuestionsJson().pipe(
                map((response: any) => {
                    return new GetQuestionsJsonSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    sendApproval$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.SEND_APPROVAL),
        switchMap((action: SendApproval) => {
            return this.monitoring_service.sendApproval(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Sent successfully`);
                    this.monitoring_service.reLoadTable(action.payload);
                    return new SendApprovalSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getSingleRolesResp$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_SINGLE_ROLE_RESP),
        switchMap((action: GetSingleRoleandResp) => {
            return this.monitoring_service.getSingleRolesResp(action.id).pipe(
                map((response: any) => {
                    return new GetSingleRoleandRespSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    updateOtherObservations$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.UPDATE_OTHER_OBSERVATIONS),
        switchMap((action: UpdateOtherObservations) => {
            return this.monitoring_service.updateOtherObservation(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Updated successfully`);
                    return new UpdateOtherObservationsSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    getOtherObservations$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_OTHER_OBSERVATIONS),
        switchMap((action: GetOtherObservations) => {
            return this.monitoring_service.getOtherObservations(action.payload).pipe(
                map((response: any) => {
                    response = response ? response : {};
                    return new GetOtherObservationsSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    updateMajorEvents$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.UPDATE_MAJOR_EVENTS),
        switchMap((action: UpdateMajorEvents) => {
            // if (action.operation_type == 'accept') {
            return this.monitoring_service.updateMajorEventIndicators(action.payload).pipe(
                map((response: any) => {
                    console.log(response)
                    this.notificationService.success(`Updated successfully`);
                    return new UpdateMajorEventsSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
            // }
        })
    );

    @Effect()
    Approval$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.APPROVE),
        switchMap((action: Approve) => {
            return this.monitoring_service.approveTable(action.payload, action.isApproved).pipe(
                map((response: any) => {
                    this.notificationService.success(response.message);
                    this.monitoring_service.reLoadTable(action.payload);
                    return new ApproveSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    Reopen$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.REOPEN),
        switchMap((action: ReopenTable) => {
            return this.monitoring_service.reopenTable(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(response.message);
                    this.monitoring_service.reLoadTable(action.payload);
                    return new ReopenTableSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    overViewOne$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_OVER_VIEW_PLF_ONE),
        switchMap((action: GetOverViewPLFOne) => {
            return this.monitoring_service.getPLf1(action.id).pipe(
                map((response: any) => {
                    return new GetOverViewPLFOneSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    overViewTwo$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_OVER_VIEW_PLF_TWO),
        switchMap((action: GetOverViewPLFTwo) => {
            return this.monitoring_service.getPLf2(action.id).pipe(
                map((response: any) => {
                    return new GetOverViewPLFTwoSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    overDetails$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_OVER_VIEW_DETAILS),
        switchMap((action: GetOverViewDetails) => {
            return this.monitoring_service.getOverViewDetails(action.payload,false).pipe(
                map((response: any) => {
                    // if(action.isBiannual){
                        return new GetOverViewDetailsSuccess(response);
                    // }
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    biannualoverDetails$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.GET_BI_ANNUAL_OVER_VIEW_DETAILS),
        switchMap((action: GetBiAnnualOverViewDetails) => {
            return this.monitoring_service.getOverViewDetails(action.payload,true).pipe(
                map((response: any) => {
                        return new GetBiAnnualOverViewDetailsSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    createIndicator$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.CREATE_INDICATOR),
        switchMap((action: CreateIndicator) => {
            return this.monitoring_service.createIndicator(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Created successfully`);

                    this.router.navigate(['home', 'program-dashboard', 'project', action.projectId, 'm-e', 'indicators', 'master-list']);
                    return new CreateIndicatorSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    editIndicator$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.EDIT_INDICATOR),
        switchMap((action: EditIndicator) => {
            return this.monitoring_service.editIndicator(action.id,action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Updated successfully`);

                    this.router.navigate(['home', 'monitoring-evaluation', 'project', action.projectId, 'indicator-detail', action.id]);
                    return new EditIndicatorSuccess(response);
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    suggestIndicator$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.SUGGEST_INDICATOR),
        switchMap((action: SuggestIndicator) => {
            return this.monitoring_service.suggestIndicator(action.payload).pipe(
                map((response: any) => {
                    this.notificationService.success(`Updated successfully`);

                    this.router.navigate(['home', 'program-dashboard', 'project', action.projectId, 'm-e', 'indicators', 'suggested-indicators']);
                    return new SuggestIndicatorSuccess(response);
                    
                }),
                catchError(err => of(new ErrorAction(err)))
            );
        })
    );

    @Effect()
    indicatorBulkUpload$ = this.action$.pipe(
        ofType(MonitoringEvaluationActionTypes.BULK_INDICATOR),
        switchMap((action: BlukIndicator) => {
            // console.log('TCL: action', action);
            //   const body = {
            //     upfile: action.payload.upfile,
            //   };
            // console.log('TCL: body', body);
            console.log('TCL: action.payload', action.payload);
            return this.monitoring_service.bulkIndicatorUpload(action.payload).pipe(
                map((response: any) => {
                    // this.location.back();
                    this.notificationService.success(`Indicators created successfully`);
                    // this.store.dispatch(new GetUsers({ limit: 40, page: 1 }));
                    this.store.dispatch(new GetListDetails('master_list',action.projectId));
                    return new BlukIndicatorSuccess(response);
                }),
                catchError(err => {
                    return of(new ErrorAction(err));
                })
            );
        })
    );
}